import { ProductCategory, ProductTypeCommon } from "@utils/constants";
import { getProductName } from "@utils/product/productNames";
import { TFunction } from "i18next";
import {
  generateGemstoneSavedSearchName,
  generateJewelrySavedSearchName,
  generateSavedSearchName,
} from "@utils/product/productFormatters";

interface ProductType {
  name: string;
  theme: string;
  productType: ProductCategory;
}
const productTypeMap: { [key: number]: ProductType } = {
  1: {
    name: "global.text.naturalDiamonds",
    theme: "diam-01",
    productType: ProductCategory.DIAMOND,
  },
  4: {
    name: "global.text.labGrownDiamonds",
    theme: "lab-01",
    productType: ProductCategory.LAB_GROWN_DIAMOND,
  },
  2: {
    name: "global.text.coloredGemstones",
    theme: "gem-01",
    productType: ProductCategory.GEMSTONE,
  },
  3: {
    name: "global.text.jewelry",
    theme: "jewelry-01",
    productType: ProductCategory.JEWELRY,
  },
};

export function convertProductType(
  savedSearches: any,
  t: TFunction,
  jewelryFilters: any
) {
  if (Array.isArray(savedSearches)) {
    savedSearches.sort((a, b) => a.type - b.type);
    // If savedSearches is an array, map each item
    return savedSearches.map((item) => {
      let generatedTitle;
      switch (item.type) {
        case 2:
          generatedTitle = generateGemstoneSavedSearchName(
            item.search_options,
            t
          )?.title;
          break;
        case 3:
          const subType =
            item.search_options?.sub_type ===
            ProductTypeCommon.LABGROWN_JEWELRY_SUB_TYPE
              ? "Lab-Grown Jewelry"
              : "Jewelry";
          const _jewelryFilters =
            jewelryFilters.find((filter) => filter?.name === subType)
              ?.filters ?? [];
          generatedTitle = generateJewelrySavedSearchName(
            item.search_options,
            t,
            _jewelryFilters,
            []
          )?.title;
          break;
        default:
          // Default case
          generatedTitle = generateSavedSearchName(
            item.search_options,
            t
          )?.title;
      }

      return {
        ...item,
        type_text:
          item?.search_options?.sub_type &&
          item?.search_options?.sub_type ===
            ProductTypeCommon.LABGROWN_JEWELRY_SUB_TYPE
            ? getProductName(ProductCategory.LABGROWN_JEWELRY, t)
            : productTypeMap[item.type].name,
        theme: productTypeMap[item.type].theme,
        productType: productTypeMap[item.type].productType,
        generated_Title:
          item.title !== generatedTitle
            ? generatedTitle === "0"
              ? "All Results"
              : generatedTitle
            : "",
      };
    });
  }
}
